<template>
    <div class="ah-page service-fee-statement-edit-page">
        <div class="page-header" id="payment-page-header" style="margin-bottom: 25px">
            <div class="ah-container medium">
                <div class="title-row" style="display: flex; justify-content: space-between; align-items: center">
                    <div class="title" style="margin: 0">
                        <h1 v-if="form.sno">編輯勞報單</h1>
                        <h1 v-else>新增勞報單</h1>
                    </div>
                </div>
            </div>
        </div>
        <el-form :model="form" :rules="rules" ref="form"  :label-position="labelPosition" label-width="200px">
            <div class="ah-container medium">
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">
                            <div style="display: flex; align-items: center; gap: 10px; padding: 5px 0">
                                <img class="user-icon" src="@/assets/img/user-icon.svg" alt="User Avatar" style="width: 20px" />
                                <span>領款人資訊</span>
                            </div>
                        </div>
                    </div>
                    <div class="panel-body" style="padding-top: 40px">
                        <el-form-item prop="personalOutsourcingSno" label="委外勞務">
                            <div class="flex-wrap">
                                <el-select
                                    v-model="form.personalOutsourcingSno"
                                    filterable
                                    value-key="sno"
                                    style="min-width: 290px; width: 70%"
                                    no-match-text="無匹配資料"
                                    remote
                                    clearable
                                    :placeholder="companyInfo.displayPersonalOutsource ? '請選擇' : '請輸入委外勞務關鍵字（至少兩個字）'"
                                    :no-data-text="getOutsourcingNoDataText()"
                                    :remote-method="outsourcingRemoteMethod"
                                    @change="onOutsourcingChange"
                                    @keydown.native.capture.enter="preventIMESelect"
                                >
                                    <el-option label="（未填寫）" :value="-1"></el-option>
                                    <el-option v-for="item in outsourcingList" :key="item.sno" :label="item.fnam" :value="item.sno" />
                                </el-select>
                                <el-tooltip :manual="isAuth('C03')" effect="light" content="您沒有「請款委外管理」權限" placement="top">
                                    <el-button icon="el-icon-plus" :disabled="!isAuth('C03')" @click="onAddOutsourcePerson"></el-button>
                                </el-tooltip>
                                <div>
                                    <el-alert v-if="form.personalOutsourcingSno === -1" type="warning" :closable="false" style="line-height: 100%; padding-top: 3px"
                                        ><i class="el-icon-warning" style="margin-right: 8px"></i> 提醒您，未填寫領款人的勞報單無法「轉送請款單」。</el-alert
                                    >
                                </div>
                            </div>
                        </el-form-item>
                        <div v-if="form.personalOutsourcingSno && form.personalOutsourcingSno !== -1" class="outsourcing-form-card">
                            <div class="card-action">
                                <div></div>
                                <div>
                                    <span v-if="isOutsourcingRequiredFieldUnfill" class="outsourcing-field-required-msg"
                                        ><i class="el-icon-warning"></i> 提醒您，該委外資料有必填欄位尚未填寫，請選擇編輯方式：</span
                                    >
                                    <template v-if="!isEnableEditCurrOutsourcing">
                                        <el-tooltip effect="light" placement="top" content="僅改本次勞報單，不連動現有委外個人資料">
                                            <el-button icon="el-icon-edit" size="mini" @click="enableEditCurrOutsourcing">編輯本次資料</el-button>
                                        </el-tooltip>
                                        <el-tooltip effect="light" placement="top" :content="isAuth('C03') ? '同步修改此單與委外個人資料' : '您沒有「請款委外管理」權限'">
                                            <el-button icon="el-icon-edit" size="mini" @click="onOutsourcingEdit" :disabled="!isAuth('C03')">編輯來源委外管理</el-button>
                                        </el-tooltip>
                                    </template>
                                    <template v-if="isEnableEditCurrOutsourcing">
                                        <el-button type="normal" icon="el-icon-close" size="small" @click="cancelEditCurrOutsourcing">取消</el-button>
                                        <el-button type="primary" icon="el-icon-check" size="small" @click="closeEditCurrOutsourcing">確定</el-button>
                                    </template>
                                </div>
                            </div>
                            <el-form-item prop="payee" label="收款人姓名" size="small">
                                <el-input v-model="form.payee" name="payee" :disabled="!isEnableEditCurrOutsourcing" :maxlength="50" :show-word-limit="true" />
                            </el-form-item>
                            <el-form-item prop="payee" label="國籍" size="small">
                                <el-radio-group v-model="form.nationality" :disabled="!isEnableEditCurrOutsourcing">
                                    <el-radio :label="0">本國籍</el-radio>
                                    <el-radio :label="1">外國籍（在台已滿183天）</el-radio>
                                    <el-radio :label="2">外國籍（在台未滿183天）</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item size="small" label="證件號碼" required>
                                <div style="display: flex; gap: 5px">
                                    <el-form-item prop="idTyp" size="small" style="width: 120px">
                                        <el-select v-model="form.idTyp" :disabled="!isEnableEditCurrOutsourcing">
                                            <el-option :key="0" :value="0" label="身分證"></el-option>
                                            <el-option :key="3" :value="3" label="營業統一編號"></el-option>
                                            <el-option :key="1" :value="1" label="護照"></el-option>
                                            <el-option :key="2" :value="2" label="居留證"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item prop="bsn" size="small" :rules="bsnRule" style="flex-grow: 1">
                                        <el-input v-model="form.bsn" name="bsn" :disabled="!isEnableEditCurrOutsourcing" :maxlength="20" :show-word-limit="true" />
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item prop="phone" label="聯絡電話" size="small">
                                <el-input v-model="form.phone" name="phone" :disabled="!isEnableEditCurrOutsourcing" :maxlength="20" :show-word-limit="true" />
                            </el-form-item>
                            <el-form-item prop="email" label="E-mail" size="small">
                                <el-input v-model="form.email" name="email" :disabled="!isEnableEditCurrOutsourcing" :maxlength="100" :show-word-limit="true" />
                            </el-form-item>
                            <el-form-item label="戶籍地址" size="small" required>
                                <div style="display: flex; gap: 5px">
                                    <el-form-item prop="permanentAdR_CODE" style="width: 85px" size="small">
                                        <el-input v-model="form.permanentAdR_CODE" name="permanentAdR_CODE" placeholder="郵遞區號" :maxlength="6" :disabled="!isEnableEditCurrOutsourcing" />
                                    </el-form-item>
                                    <el-form-item v-if="form.nationality === 0" prop="permanentAddrCty" style="width: 100px" size="small">
                                        <TwCountySelect v-model="form.permanentAddrCty" key="county" placeholder="縣市" style="width: 100%" :disabled="!isEnableEditCurrOutsourcing" />
                                    </el-form-item>
                                    <el-form-item v-if="form.nationality !== 0" prop="permanentAddrAra" style="width: 300px" size="small">
                                        <CountrySelect v-model="form.permanentAddrAra" key="county" placeholder="地區" style="width: 100%" :disabled="!isEnableEditCurrOutsourcing" />
                                    </el-form-item>
                                    <el-form-item prop="permanentAddr" style="flex-grow: 1" size="small">
                                        <el-input
                                            v-model="form.permanentAddr"
                                            name="permanentAddr"
                                            placeholder="戶籍地址"
                                            :disabled="!isEnableEditCurrOutsourcing"
                                            :maxlength="50"
                                            :show-word-limit="true"
                                        />
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item label="聯絡地址" size="small" required>
                                <div style="display: flex; gap: 5px">
                                    <el-form-item prop="adR_CODE" style="width: 85px" size="small">
                                        <el-input v-model="form.adR_CODE" name="adR_CODE" placeholder="郵遞區號" :maxlength="6" :disabled="!isEnableEditCurrOutsourcing" />
                                    </el-form-item>
                                    <el-form-item v-if="form.nationality === 0" prop="contactAddrCty" style="width: 100px" size="small">
                                        <TwCountySelect v-model="form.contactAddrCty" key="contactAddrCty" placeholder="縣市" style="width: 100%" :disabled="!isEnableEditCurrOutsourcing" />
                                    </el-form-item>
                                    <el-form-item v-if="form.nationality !== 0" prop="contactAddrAra" style="width: 300px" size="small">
                                        <CountrySelect v-model="form.contactAddrAra" key="county" placeholder="地區" style="width: 100%" :disabled="!isEnableEditCurrOutsourcing" />
                                    </el-form-item>
                                    <el-form-item prop="contactAddr" style="flex-grow: 1" size="small">
                                        <el-input
                                            v-model="form.contactAddr"
                                            name="contactAddr"
                                            placeholder="聯絡地址"
                                            :disabled="!isEnableEditCurrOutsourcing"
                                            :maxlength="50"
                                            :show-word-limit="true"
                                        />
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item label="證件正反面" size="small">
                                <div style="display: grid; grid-template-columns: 50% 50%; gap: 5px">
                                    <el-form-item prop="idCardFront" size="small">
                                        <div v-if="form.idCardFront" class="document-block">
                                            <el-image :src="form.idCardFront" :previewSrcList="[form.idCardFront]" class="id-card-image" fit="contain"></el-image>
                                        </div>
                                        <div v-if="!form.idCardFront && !isEnableEditCurrOutsourcing" class="id-card-image none">(無正面)</div>
                                        <ahUploader
                                            v-if="isEnableEditCurrOutsourcing"
                                            :value="form.idCardFront"
                                            ref="ahUploader"
                                            head-shot
                                            accept="image/png, image/jpeg"
                                            @change="($event) => onChangeAttachment($event, 'idCardFront')"
                                            :watermark="`僅供 ${companyName} 請款使用`"
                                        ></ahUploader>
                                    </el-form-item>
                                    <el-form-item prop="idCardBack" size="small">
                                        <div v-if="form.idCardBack" class="document-block">
                                            <el-image :src="form.idCardBack" :previewSrcList="[form.idCardBack]" class="id-card-image" fit="contain"></el-image>
                                        </div>
                                        <div v-if="!form.idCardBack && !isEnableEditCurrOutsourcing" class="id-card-image none">(無背面)</div>
                                        <ahUploader
                                            v-if="isEnableEditCurrOutsourcing"
                                            :value="form.idCardBack"
                                            ref="ahUploader"
                                            head-shot
                                            accept="image/png, image/jpeg"
                                            :watermark="`僅供 ${companyName} 請款使用`"
                                            @change="($event) => onChangeAttachment($event, 'idCardBack')"
                                        />
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item prop="hasUnionInsurance" label="投保職業工會" size="small">
                                <template slot="label">投保職業工會<ahTip>有投保職業工會，免扣二代健保。</ahTip> </template>
                                <el-radio-group v-model="form.hasUnionInsurance" :disabled="!isEnableEditCurrOutsourcing">
                                    <el-radio :label="false">否</el-radio>
                                    <el-radio :label="true">是</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item v-if="form.hasUnionInsurance" prop="unionInsuranceExpireDate" label="投保工會有效日期" size="small">
                                <div style="display: flex; gap: 10px">
                                    <el-date-picker
                                        v-model="form.unionInsuranceExpireDate"
                                        type="date"
                                        value-format="timestamp"
                                        placeholder="選擇日期"
                                        :disabled="!isEnableEditCurrOutsourcing"
                                        style="width: 160px"
                                    ></el-date-picker>
                                </div>
                            </el-form-item>
                            <el-form-item v-if="form.hasUnionInsurance" prop="unionInsuranceDoc" label="投保工會證明" size="small">
                                <div v-if="!form.unionInsuranceDoc">(無)</div>
                                <el-image v-if="form.unionInsuranceDoc" :src="form.unionInsuranceDoc" :previewSrcList="[form.unionInsuranceDoc]" class="doc-image" it="contain"></el-image>
                                <ahUploader
                                    v-if="isEnableEditCurrOutsourcing"
                                    :value="form.unionInsuranceDoc"
                                    ref="ahUploader"
                                    head-shot
                                    accept="image/png, image/jpeg"
                                    :watermark="`僅供 ${companyName} 請款使用`"
                                    class="doc-image"
                                    @change="($event) => onChangeAttachment($event, 'unionInsuranceDoc')"
                                />
                            </el-form-item>
                            <div v-if="isEnableEditCurrOutsourcing" class="card-footer">
                                <div></div>
                                <div>
                                    <el-button type="normal" icon="el-icon-close" size="small" @click="cancelEditCurrOutsourcing">取消</el-button>
                                    <el-button type="primary" icon="el-icon-check" size="small" @click="closeEditCurrOutsourcing">確定</el-button>
                                </div>
                            </div>
                        </div>
                        <el-form-item v-if="form.personalOutsourcingSno" prop="toBeAddFile" label="標示為待補證件">
                            <template slot="label">標示為待補證件 <ah-tip>待補證件將無法轉送請款單</ah-tip></template>
                            <el-checkbox v-model="form.toBeAddFile" style="margin-bottom: 20px"></el-checkbox>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">勞務內容</div>
                    </div>
                    <div class="panel-body" style="padding-top: 40px">
                        <el-form-item prop="projectSno" label="專案歸屬">
                            <el-radio-group v-model="isProject" @change="onProjectTypChange">
                                <el-radio :label="false">無專案</el-radio>
                                <el-radio :label="true">有專案</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item v-if="isProject" prop="projectSno" label="所屬專案">
                            <template slot="label">所屬專案<ah-tip>有開放勞報單申請的專案</ah-tip></template>
                            <el-select
                                v-model="selectedProject"
                                value-key="sno"
                                filterable
                                no-match-text="無匹配專案"
                                clearable
                                style="width: 100%"
                                remote
                                :placeholder="companyInfo.displayProject ? '請選擇' : '請輸專案關鍵字'"
                                :no-data-text="companyInfo.displayProject ? '無資料' : '無匹配資料'"
                                :remote-method="projectRemoteMethod"
                                @change="onProjectChange"
                                @clear="onProjectClear"
                                @keydown.native.capture.enter="preventIMESelect"
                            >
                                <el-option v-for="item in projectList" :key="item.poo" :label="item.nam" :value="item" />
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="nam" label="勞務摘要">
                            <el-input
                                type="textarea"
                                name="nam"
                                v-model="form.nam"
                                :maxlength="200"
                                :show-word-limit="true"
                                class="ah-el-input-textarea large"
                                autosize
                                resize="none"
                                @keydown.enter.native="onNamInputKeydown($event)"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="description" label="勞務內容">
                            <el-input v-model="form.description" type="textarea" rows="6" :maxlength="1000" :show-word-limit="true"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">領款金額</div>
                    </div>
                    <div class="panel-body" style="padding-top: 40px">
                        <el-form-item prop="incomeType" label="所得類別">
                            <el-select
                                v-model="form.incomeType"
                                filterable
                                placeholder="請選擇"
                                style="min-width: 310px; margin-right: 8px"
                                no-data-text="無資料"
                                no-match-text="無匹配資料"
                                @change="onChangeIncomeType"
                            >
                                <el-option v-for="item in serviceTypeList" :key="item.key" :label="item.label" :value="item.value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="form.incomeType === 1 || form.incomeType === 2" prop="serviceType" label="業別代號">
                            <el-select v-model="form.serviceType" filterable placeholder="請選擇" style="width: 95%" no-data-text="無資料" no-match-text="無匹配資料">
                                <el-option v-for="item in serviceSubTypeList" :key="item.key" :label="`${item.key}：${item.label}`" :value="item.key" />
                            </el-select>
                        </el-form-item>
                        <el-form-item v-else-if="form.incomeType === 0" prop="otherServiceType" label="其他類別說明">
                            <el-input v-model="form.otherServiceType" :maxlength="50" :show-word-limit="true" style="width: 310px" />
                        </el-form-item>
                        <el-form-item v-if="form.incomeType !== null">
                            <ah-outsourcing-personal-tax-info :incomeType="form.incomeType">
                                <div>
                                    <span style="font-size: 10pt; margin-right: 10px">自動計算扣繳率</span>
                                    <el-switch v-model="isEnableAutoTax" @change="onChangeEnableAutoTax"></el-switch>
                                </div>
                            </ah-outsourcing-personal-tax-info>
                        </el-form-item>
                        <el-form-item prop="amt" label="應付總額" style="margin-top: 30px">
                            <div class="flex-wrap">
                                <ah-el-select-cny v-model="form.cny" :availables="availableCny" width="100px" @change="onCnyChange" />
                                <money-input v-model="form.amt" :precision="form.cny == 'TWD' ? 0 : 4" @change="onAmtChange" style="max-width: 240px" :suffix="form.cny === 'TWD' ? '元' : form.cny" />
                            </div>
                        </el-form-item>
                        <el-form-item v-if="form.cny !== 'TWD'" prop="cnyRat" label="約定匯率" style="margin-bottom: 45px">
                            <div class="flex-wrap">
                                <money-input v-model="form.cnyRat" :precision="4" style="max-width: 100px;" @change="onCnyRatChange" />
                                <money-input v-model="twdAmt" disabled style="width: 240px" suffix="約當台幣" />
                            </div>
                        </el-form-item>
                        <el-form-item prop="taxAmt" label="− 代扣所得稅款">
                            <div class="flex-wrap">
                                <money-input v-model="form.taxRatio" :disabled="isEnableAutoTax" style="width: 120px;" :precision="2" @change="onTaxRatioChange" suffix="%" />
                                <money-input v-model="form.taxAmt" @change="onTaxAmtChange" style="width: 180px" :suffix="form.cny === 'TWD' ? '元' : 'TWD'" />
                                <template v-if="form.cny !== 'TWD'">
                                    <money-input v-model="taxAmtInOriginCny" :precision="4" :suffix="form.cny" style="width: 180px;" disabled />
                                    <ahRichPopInfo :width="430" title="代扣所得稅款（外幣）">
                                        <template slot="content">
                                            <div style="text-align: left">
                                                <div>= ((應付總額 * 約定匯率) * 代扣所得稅率) / 約定匯率</div>
                                                <div>= (({{ form.amt.toLocaleString() }} * {{ form.cnyRat }}) * {{ form.taxRatio }}%) / {{ form.cnyRat }}</div>
                                                <div>= {{ taxAmtInOriginCny.toLocaleString() }}</div>
                                            </div>
                                        </template>
                                        <span class="tip"><i class="el-icon-warning-outline" style="color: #888"></i></span>
                                    </ahRichPopInfo>
                                </template>
                            </div>
                        </el-form-item>
                        <el-form-item prop="gen2Amt" label="− 代扣二代健保">
                            <div class="flex-wrap">
                                <money-input v-model="form.gen2Ratio" :disabled="isEnableAutoTax" style="width: 120px;" :precision="2" @change="onGen2RatioChange" suffix="%" />
                                <money-input v-model="form.gen2Amt" @change="onGen2AmtChange" style="width: 180px" :suffix="form.cny === 'TWD' ? '元' : 'TWD'" />
                                <template v-if="form.cny !== 'TWD'">
                                    <money-input v-if="form.cny !== 'TWD'" v-model="gen2AmtInOriginCny" :precision="4" :suffix="form.cny" style="width: 180px;" disabled />
                                    <ahRichPopInfo :width="450" title="代扣二代健保（外幣）">
                                        <template slot="content">
                                            <div style="text-align: left">
                                                <div>= ((應付總額 * 約定匯率) * 代扣二代健保費率) / 約定匯率</div>
                                                <div>= (({{ form.amt.toLocaleString() }} * {{ form.cnyRat }}) * {{ form.gen2Ratio }}%) / {{ form.cnyRat }}</div>
                                                <div>= {{ gen2AmtInOriginCny.toLocaleString() }}</div>
                                            </div>
                                        </template>
                                        <span class="tip"><i class="el-icon-warning-outline" style="color: #888"></i></span>
                                    </ahRichPopInfo>
                                </template>
                            </div>
                        </el-form-item>
                        <el-form-item label="＝ 實付金額">
                            <div v-if="form.cny !== 'TWD'" style="margin-bottom: 5px">
                                <money-input v-model="realPayAmtInOriginCny" disabled style="width: 305px" :precision="4" :suffix="form.cny" />
                                <ahRichPopInfo :width="550" title="實付金額（外幣）">
                                    <template slot="content">
                                        <div style="text-align: left">
                                            <!-- (Math.round(this.form.amt * this.form.cnyRat) - this.form.taxAmt - this.form.gen2Amt) / this.form.cnyRat; -->
                                            <div>= ((外幣應付總額 * 約定匯率) - 代扣所得稅款(台幣) - 代扣二代健保(台幣)) / 約定匯率</div>
                                            <div>
                                                = (({{ form.amt.toLocaleString() }} * {{ form.cnyRat }}) - {{ form.taxAmt.toLocaleString() }} - {{ form.gen2Amt.toLocaleString() }}) / {{ form.cnyRat }}
                                            </div>
                                            <div>= {{ realPayAmtInOriginCny.toLocaleString() }}</div>
                                        </div>
                                    </template>
                                    <span class="tip" style="margin-left: 10px"><i class="el-icon-warning-outline" style="color: #888"></i></span>
                                </ahRichPopInfo>
                            </div>
                            <div>
                                <money-input v-model="form.realPayAmt" disabled style="width: 305px" :suffix="form.cny === 'TWD' ? '元' : '約當台幣'" />
                                <ahRichPopInfo v-if="form.cny === 'TWD'" :width="350" title="實付金額">
                                    <template slot="content">
                                        <div style="text-align: left">
                                            <div>= 應付總額 - 代扣所得稅款 - 代扣二代健保</div>
                                            <div>= {{ form.amt.toLocaleString() }} - {{ form.taxAmt.toLocaleString() }} - {{ form.gen2Amt.toLocaleString() }}</div>
                                            <div>= {{ form.realPayAmt.toLocaleString() }}</div>
                                        </div>
                                    </template>
                                    <span class="tip" style="margin-left: 10px"><i class="el-icon-warning-outline" style="color: #888"></i></span>
                                </ahRichPopInfo>
                                <ahRichPopInfo v-if="form.cny !== 'TWD'" :width="550" title="實付金額（約當台幣）">
                                    <template slot="content">
                                        <div style="text-align: left">
                                            <div>= (外幣應付總額 * 約定匯率) - 代扣所得稅款(台幣) - 代扣二代健保(台幣)</div>
                                            <div>= ({{ form.amt.toLocaleString() }} * {{ form.cnyRat }}) - {{ form.taxAmt.toLocaleString() }} - {{ form.gen2Amt.toLocaleString() }}</div>
                                            <div>= {{ form.realPayAmt.toLocaleString() }}</div>
                                        </div>
                                    </template>
                                    <span class="tip" style="margin-left: 10px"><i class="el-icon-warning-outline" style="color: #888"></i></span>
                                </ahRichPopInfo>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small">
                        <div class="panel-title">支領方式</div>
                    </div>
                    <div class="panel-body" style="padding-top: 40px">
                        <el-form-item prop="plannedPayDat" label="預計支領日期">
                            <el-date-picker v-model="form.plannedPayDat" type="date" value-format="timestamp" placeholder="選擇日期"> </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="plannedPayWay" label="預計支領方式">
                            <el-radio-group v-model="form.plannedPayWay" @change="onChangePlannedPayWay">
                                <el-radio :label="1" :disabled="form.cny !== 'TWD'">現金</el-radio>
                                <el-radio :label="2">銀行轉帳</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item prop="vdR_BNK_SNO" v-if="form.plannedPayWay === 2" label="領款人收款帳戶">
                            <template v-if="!selectedOutsourcing">（請先選擇領款人）</template>
                            <template v-if="selectedOutsourcing">
                                <div class="flex-wrap">
                                    <el-select
                                        v-model="form.vdR_BNK_SNO"
                                        filterable
                                        placeholder="請選擇"
                                        style="min-width: 290px;"
                                        no-data-text="無資料"
                                        no-match-text="無匹配資料"
                                        @change="onBnkChange"
                                    >
                                        <el-option
                                            v-for="item in selectedOutsourcing.vendorBanks"
                                            :key="item.sno"
                                            :label="getOutsourcingBankLabel(item)"
                                            :value="item.sno"
                                        />
                                    </el-select>
                                    <el-tooltip :manual="isAuth('C03')" effect="light" content="您沒有「請款委外管理」權限" placement="top-end">
                                        <el-button icon="el-icon-edit" @click="onOutsourcingEdit"></el-button>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-form-item>
                        <div v-if="form.plannedPayWay === 2 && form.vdR_BNK_SNO" class="outsourcing-form-card">
                            <div class="card-action">
                                <template v-if="!isEnableEditCurrOutsourcingBank">
                                    <el-tooltip effect="light" placement="top" content="僅改本次勞報單，不連動現有委外個人資料">
                                        <el-button icon="el-icon-edit" size="mini" @click="enableEditCurrOutsourcingBank">編輯本次資料</el-button>
                                    </el-tooltip>
                                    <el-tooltip effect="light" placement="top" :content="isAuth('C03') ? '同步修改此單與委外個人資料' : '您沒有「請款委外管理」權限'">
                                        <el-button icon="el-icon-edit" size="mini" @click="onOutsourcingEdit" :disabled="!isAuth('C03')">編輯來源委外管理</el-button>
                                    </el-tooltip>
                                </template>
                                <template v-if="isEnableEditCurrOutsourcingBank">
                                    <el-button type="normal" icon="el-icon-close" size="small" @click="cancelEditCurrOutsourcingBank">取消</el-button>
                                    <el-button type="primary" icon="el-icon-check" size="small" @click="closeEditCurrOutsourcingBank">確定</el-button>
                                </template>
                            </div>
                            <el-form-item prop="accountType" label="帳戶類型" size="small">
                                <el-radio-group v-model="form.accountType" :disabled="!isEnableEditCurrOutsourcingBank">
                                    <el-radio :label="1">本國帳戶</el-radio>
                                    <el-radio :label="2">外國帳戶</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item v-if="form.accountType === 1" prop="bnK_BOO" label="銀行" size="small">
                                <ah-el-select-bank
                                    v-model="form.bnkBoo"
                                    :branch="form.bnkDoo"
                                    @branchInput="form.bnkDoo = $event"
                                    :disabled="!isEnableEditCurrOutsourcingBank"
                                    style="max-width: 550px"
                                ></ah-el-select-bank>
                            </el-form-item>
                            <el-form-item prop="bnkNam" label="存摺戶名" size="small">
                                <el-input v-model="form.bnkNam" name="bnkNam" :disabled="!isEnableEditCurrOutsourcingBank" :maxlength="50" :show-word-limit="true" />
                            </el-form-item>
                            <el-form-item prop="bnkAcc" label="收款帳號" size="small">
                                <el-input v-model="form.bnkAcc" name="bnkAcc" :disabled="!isEnableEditCurrOutsourcingBank" :maxlength="200" :show-word-limit="true" />
                            </el-form-item>
                            <el-form-item prop="bnkNote" label="帳戶備註" size="small">
                                <el-input v-model="form.bnkNote" name="bnkNote" :disabled="!isEnableEditCurrOutsourcingBank" :maxlength="20" :show-word-limit="true" />
                            </el-form-item>
                            <el-form-item v-if="form.accountType === 2" prop="abroadBankName" label="外國銀行名稱" size="small">
                                <el-input v-model="form.abroadBankName" name="abroadBankName" :disabled="!isEnableEditCurrOutsourcingBank" :maxlength="200" show-word-limit />
                            </el-form-item>
                            <el-form-item v-if="form.accountType === 2" prop="swiftCode" label="SWIFT Code" size="small">
                                <el-input v-model="form.swiftCode" name="swiftCode" :disabled="!isEnableEditCurrOutsourcingBank" :maxlength="40" :show-word-limit="true" />
                            </el-form-item>
                            <el-form-item v-if="form.passbookDoc" prop="passbookDoc" label="存摺封面" size="small">
                                <div v-if="!form.passbookDoc">(無)</div>
                                <el-image v-if="form.passbookDoc" :src="form.passbookDoc" :previewSrcList="[form.passbookDoc]" class="doc-image" it="contain"></el-image>
                                <ahUploader
                                    v-if="isEnableEditCurrOutsourcingBank"
                                    :value="form.passbookDoc"
                                    ref="ahUploader"
                                    head-shot
                                    accept="image/png, image/jpeg"
                                    :watermark="`僅供 ${companyName} 請款使用`"
                                    class="doc-image"
                                    @change="($event) => onChangeAttachment($event, 'unionInsuranceDoc')"
                                />
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div style="display: flex; justify-content: space-between; margin-top: 30px">
                    <div>
                        <el-tooltip placement="top" :manual="isDeleteAvailable">
                            <template slot="content">已請款，無法刪除，請先作廢請款單 {{ form.payoo }}</template>
                            <el-button v-if="form.sno" :type="isDeleteAvailable ? 'danger' : 'normal'" :disabled="!isDeleteAvailable" @click="onDelete" icon="el-icon-delete"> 刪除 </el-button>
                        </el-tooltip>
                    </div>
                    <div>
                        <el-button icon="el-icon-close" @click="onClose">取消</el-button>
                        <el-button type="primary" class="primary-action" :loading="isSubmitting" id="payment-add-page-submit-btn" @click="onSubmit" icon="el-icon-check">{{
                            form.sno ? "儲存" : "送出"
                        }}</el-button>
                    </div>
                </div>
            </div>
        </el-form>
        <person-upsert-dialog
            :sno="outsourcingPersonUpsertDialog.sno"
            :is-service-fee-mode="true"
            :visible="outsourcingPersonUpsertDialog.visible"
            @close="onOutsourcingPersonUpsertDialogClose"
            @submit="onOutsourcingPersonSubmitted"
        />
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { isGuiNumberValid, isNationalIdentificationNumberValid } from 'taiwan-id-validator';
import ahElSelectCny from '@/components/ui/ahElSelectCny.vue';
import ahUploader from '@/components/ui/Uploader/ahUploader.vue';
import ahOutsourcingPersonalTaxInfo from '@/components/ui/ahOutsourcingPersonalTaxInfo.vue';
import { PersonUpsertDialog } from '@/components/dashboard/Outsourcing';
import {
    serviceFeeStatementType, serviceTypeList, serviceType9AList, serviceType9BList, nationalityList, serviceFeePlannedPayWay, paymentPayWay,
} from '@/assets/commonData/options';
import { getTaxAmtInfo, getGen2AmtInfo } from '@/utils/OutsourcingPersonalTaxHelpers';
import TwCountySelect from '@/components/ui/TwCountySelect.vue';
import ahElSelectBank from '@/components/ui/ahElSelectBank.vue';
import CountrySelect from '@/components/ui/CountrySelect.vue';

export default {
    components: {
        ahElSelectCny,
        ahOutsourcingPersonalTaxInfo,
        ahUploader,
        PersonUpsertDialog,
        TwCountySelect,
        ahElSelectBank,
        CountrySelect,
    },
    data() {
        // 驗證統編
        const validateBsnComp = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入統一編號。'));
            } else if (!isGuiNumberValid(value, true)) {
                callback(new Error('統一編號格式不正確'));
            } else {
                callback();
            }
        };

        const validateBsnId = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入身分證號碼。'));
            } else if (!isNationalIdentificationNumberValid(value)) {
                callback(new Error('身分證號碼格式不正確'));
            } else {
                callback();
            }
        };
        return {
            // 表單
            form: {
                sno: null,
                typ: 1,
                nam: '',
                projectSno: null,
                description: '',
                toBeAddFile: false,
                personalOutsourcingSno: null,
                nationality: 0,
                idTyp: 0,
                bsn: null,
                payee: null,
                phone: null,
                email: null,
                permanentAddrCty: null,
                permanentAddr: null,
                contactAddrCty: null,
                contactAddr: null,
                idCardFront: null,
                idCardBack: null,
                unionInsuranceDoc: null,
                passbookDoc: null,
                incomeType: null,
                serviceType: null,
                plannedPayDat: null,
                plannedPayWay: 1, // 1:現金, 2:銀行轉帳
                bnkBoo: null,
                bnkDoo: null,
                bnkNam: null,
                bnkAcc: null,
                amt: 0,
                cny: 'TWD',
                cnyRat: 1,
                hasUnionInsurance: false,
                unionInsuranceExpireDate: null,
                taxRatio: 10,
                taxAmt: 0,
                gen2Ratio: 2.11,
                gen2Amt: 0,
                realPayAmt: 0,
                permanentAddrAra: null,
                permanentAdR_CODE: null,
                adR_CODE: null,
                contactAddrAra: null,
                accountType: 1,
                abroadBankName: null,
                swiftCode: null,
                otherServiceType: null,
                vdR_BNK_SNO: null,
                projectNam: null,
            },

            // 表單驗證
            rules: {
                nam: [{ required: true, message: '請輸入勞務摘要' }],
                personalOutsourcingSno: [{ required: true, message: '請選擇委外勞務' }],
                nationality: [{ required: true, message: '請選擇國籍' }],
                idTyp: [{ required: true, message: '請選擇證件類型' }],
                bsn: [
                    {
                        required: true,
                        message: '請輸入統一編號',
                        trigger: 'blur',
                    },
                    { validator: validateBsnId, trigger: 'blur' },
                ],
                payee: [{ required: true, message: '請輸入領款人姓名' }],
                phone: [{ required: true, message: '請輸入聯絡電話' }],
                permanentAddrCty: [{ required: true, message: '請選擇縣市' }],
                permanentAddrAra: [{ required: true, message: '請選擇地區' }],
                permanentAddr: [{ required: true, message: '請輸入戶籍地址' }],
                contactAddrCty: [{ required: true, message: '請選擇縣市' }],
                contactAddrAra: [{ required: true, message: '請輸入地區' }],
                contactAddr: [{ required: true, message: '請輸入聯絡地址' }],
                incomeType: [{ required: true, message: '請輸入所得類別' }],
                otherServiceType: [{ required: true, message: '請輸入其他業務類別' }],
                serviceType: [{ required: true, message: '請輸入業務類別' }],
                plannedPayDat: [{ required: true, message: '請輸入預計付款日期' }],
                plannedPayWay: [{ required: true, message: '請輸入預計付款方式' }],
                accountType: [{ required: true, message: '請輸入帳戶類型' }],
                bnkBoo: [{ required: true, message: '請輸入收款銀行' }],
                abroadBankName: [{ required: true, message: '請輸入銀行名稱' }],
                swiftCode: [{ required: true, message: '請輸入SWIFT Code' }],
                bnkNam: [{ required: true, message: '請輸入存摺戶名' }],
                bnkAcc: [{ required: true, message: '請輸入收款帳號' }],
                amt: [{ required: true, message: '請輸入應付總額' }],
                cnyRat: [{ required: true, message: '請輸入約定匯率' }],
                hasUnionInsurance: [{ required: true, message: '請輸入投保工會' }],
                unionInsuranceExpireDate: [{ required: true, message: '請輸入投保工會有效日期' }],
                taxAmt: [{ required: true, message: '請輸入代扣所得稅款（台幣）' }],
                gen2Amt: [{ required: true, message: '請輸入代扣二代健保（台幣）' }],
                bsn_id: [{ required: true, validator: validateBsnId, trigger: 'blur' }],
                bsn_comp: [{ required: true, validator: validateBsnComp, trigger: 'blur' }],
                vdR_BNK_SNO: [{ required: true, message: '請選擇領款人收款帳戶' }],
            },

            // 新增委外勞務視窗
            outsourcingPersonUpsertDialog: {
                visible: false,
                sno: null,
            },

            // Flags
            mode: 'add',
            isLoading: false,
            isSubmitting: false,
            isProject: false,
            isEnableAutoTax: true,
            isEnableEditCurrOutsourcing: false,
            isEnableEditCurrOutsourcingBank: false,
            labelPosition: 'left',

            // 選項
            projectList: [],
            outsourcingList: [],
            serviceFeeStatementType,
            serviceTypeList,
            nationalityList,
            serviceFeePlannedPayWay,
            paymentPayWay,

            // TEMP
            selectedProject: null,
            selectedOutsourcing: null,
            selectedBnkSno: null,
            taxAmtInOriginCny: 0,
            gen2AmtInOriginCny: 0,
            realPayAmtTwd: 0,
            realPayAmtInOriginCny: 0,
            originalPersonalOutsourcingSno: null,
            latestOutsourcingData: null, // 最新的委外勞務資料（編輯時使用）
            savedOutsouringData: {},
            outsourcingQuery: '',
        };
    },
    computed: {
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
            userSno: 'account/userSno',
            cnyOptions: 'cny/cnyOptions',
        }),
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
        serviceSubTypeList() {
            switch (this.form.incomeType) {
            case 1:
                return serviceType9AList;
            case 2:
                return serviceType9BList;
            default:
                return [];
            }
        },
        twdAmt() {
            return Math.round(this.form.amt * this.form.cnyRat);
        },

        // 可選幣別
        availableCny() {
            // 專案只能選專案幣別＆台幣
            if (this.selectedProject) {
                return [this.selectedProject.cny, 'TWD'];
            }
            return null; // 其他：不限幣別
        },

        isCreator() {
            return this.form.crtSno === this.$store.getters['account/userSno'];
        },
        isDeleteAvailable() {
            return this.form.status === 3 && (this.isAuth('H02') || this.isCreator);
        },
        isOutsourcingRequiredFieldUnfill() {
            // 本國籍
            if (this.form.nationality === 0) {
                return (
                    !this.form.payee
                    || !this.form.bsn
                    || !this.form.phone
                    || !this.form.permanentAddr
                    || !this.form.permanentAddrCty
                    || !this.form.permanentAddr
                    || !this.form.contactAddrCty
                    || !this.form.contactAddr
                );
            }
            // 外國籍
            return (
                !this.form.payee
                || !this.form.bsn
                || !this.form.phone
                || !this.form.permanentAddr
                || !this.form.permanentAddrAra
                || !this.form.permanentAddr
                || !this.form.contactAddrAra
                || !this.form.contactAddr
            );
        },
        bsnRule() {
            if (this.form.nationality === 0) {
                if (this.form.idTyp === 0) return this.rules.bsn_id;
                if (this.form.idTyp === 3) return this.rules.bsn_comp;
            }

            return [{ required: true, message: `請輸入${this.bsnLabelName}` }];
        },
    },

    async mounted() {
        // 網址有 sno，設為編輯模式
        if (this.$route.params.sno) {
            await this.loadSavedServiceFee(this.$route.params.sno);
        }

        // 複製模式，清空特定欄位
        if (this.$route.query.copyFrom) {
            await this.loadSavedServiceFee(this.$route.query.copyFrom);
            this.form.sno = null;
            this.form.audit = null;
            this.form.systemNo = null;
            this.form.paymentSno = null;
            this.form.payoo = null;
        }

        // 預設進入頁面時是新增模式
        await this.fetchOutsourcingList(!this.companyInfo.displayPersonalOutsource, this.form.personalOutsourcingNam);
    },
    watch: {
        'companyInfo.displayPersonalOutsource': {
            async handler(newValue, oldValue) {
                if (typeof newValue === 'boolean' && typeof oldValue !== 'boolean') {
                    await this.fetchOutsourcingList(!newValue, this.form.personalOutsourcingNam);
                }
            },
        },
    },
    created() {
        window.addEventListener('resize', this.handleWindowResize);
        this.handleWindowResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleWindowResize);
    },
    methods: {
        /**
         * 偵聽視窗大小變更
         */
        handleWindowResize() {
            this.labelPosition = window.innerWidth < 768 ? 'top' : 'right';
        },
        async loadSavedServiceFee(sno) {
            this.form = await this.fetchData(sno);
            if (this.form) {
                this.savedOutsouringData.sno = this.form.personalOutsourcingSno;

                // 選取專案
                if (this.form.projectSno) {
                    // 載入專案清單，並選取該專案
                    this.isProject = true; // 設定"有專案"
                    console.log(this.form);
                    await this.fetchProjectList(!this.companyInfo.displayProject, this.form.projectNam);
                    this.selectedProject = _.find(this.projectList, ['sno', this.form.projectSno]);

                    // 找不到專案
                    if (!this.selectedProject) {
                        this.$message.warning('找不到專案');
                    }
                }

                // 載入委外勞務資料
                if (this.form.personalOutsourcingSno && this.form.personalOutsourcingSno !== -1) {
                    this.selectedOutsourcing = await this.fetchOutsourcingData(this.form.personalOutsourcingSno);
                }

                // 更新即時計算的金額
                this.updateAutoTaxAndGen2();
                this.updateRealPayAmt();
            } else {
                this.$message.error('找不到委外勞務資料!');
            }
        },
        // 取得勞報單資料（編輯）
        async fetchData(sno) {
            try {
                const resp = await this.$api({
                    url: 'ServiceOrder/GetServiceFeeStatement',
                    method: 'GET',
                    params: { sno },
                });
                return resp.data.item;
            } catch (e) {
                console.log(e);
            }
            return null;
        },

        // 取得專案列表
        async fetchProjectList(init, query) {
            console.log('query', query);
            try {
                const resp = await this.$api({
                    url: 'ServiceOrder/GetProjectOptions',
                    method: 'GET',
                    params: { keyword: query },
                });

                if (init) this.projectList = resp.data.items.filter((o) => o.sno === this.form.projectSno);
                else this.projectList = resp.data.items;
            } catch (e) {
                console.log(e);
            }
        },
        projectRemoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            if (!trimmedQuery) return;

            this.fetchProjectList(false, query);
        },

        // 取得委外勞務
        async fetchOutsourcingList(init, query) {
            try {
                const resp = await this.$api({
                    url: 'ServiceOrder/GetPersonalOutsourcingList',
                    method: 'GET',
                    params: { nam: query },
                });
                if (init) this.outsourcingList = resp.data.items.filter((o) => o.sno === this.form.personalOutsourcingSno);
                else this.outsourcingList = resp.data.items;
            } catch (e) {
                console.log(e);
            }
        },
        outsourcingRemoteMethod(query) {
            const trimmedQuery = this.getTrimmedQuery(query);
            this.outsourcingQuery = trimmedQuery;

            if (!trimmedQuery || (!this.companyInfo.displayPersonalOutsource && trimmedQuery.length < 2)) {
                this.outsourcingList = [];
                return;
            }

            this.fetchOutsourcingList(false, query);
        },

        getTrimmedQuery(str) {
            return str
                .split('')
                .filter((c) => c !== ' ')
                .join('');
        },

        // 是否有專案的切換
        async onProjectTypChange(val) {
            if (val === false) {
                // 無專案，清空專案相關欄位
                this.form.projectSno = null;
                this.selectedProject = null;
            } else {
                // 有專案，重新載入清單
                await this.fetchProjectList(!this.companyInfo.displayProject);
            }
        },

        // 當選取專案
        onProjectChange(val) {
            this.form.projectSno = val.sno;
            this.form.cny = val.cny;
            this.onCnyChange();
        },

        onProjectClear() {
            this.projectList = [];
            this.form.projectSno = null;
            this.selectedProject = null;
        },

        // 取得委外個人細節資料
        async fetchOutsourcingData(sno) {
            try {
                const resp = await this.$api({
                    url: 'ServiceOrder/GetPersonalOutsourcingBySno',
                    method: 'GET',
                    params: { sno },
                });
                return resp.data.item;
            } catch (e) {
                console.log(e);
            }
            return null;
        },

        // 當選取委外勞務
        async onOutsourcingChange(sno) {
            // 暫存清空前資料
            const prevVdrBnkSno = this.form.vdR_BNK_SNO;

            // 先清除領款人相關資訊
            this.form.nationality = 0;
            this.form.idTyp = 0;
            this.form.bsn = null;
            this.form.payee = null;
            this.form.phone = null;
            this.form.email = null;
            this.form.permanentAddrCty = null;
            this.form.permanentAddr = null;
            this.form.permanentAddrAra = null;
            this.form.permanentAdR_CODE = null;
            this.form.adR_CODE = null;
            this.form.contactAddr = null;
            this.form.contactAddrAra = null;
            this.form.contactAddrCty = null;
            this.form.idCardFront = null;
            this.form.idCardBack = null;
            this.form.unionInsuranceDoc = null;
            this.form.hasUnionInsurance = false;
            this.form.unionInsuranceExpireDate = null;
            this.selectedBnkSno = null;
            this.form.accountType = null;
            this.form.bnkBoo = null;
            this.form.bnkDoo = null;
            this.form.abroadBankName = null;
            this.form.swiftCode = null;
            this.form.bnkNam = null;
            this.form.bnkAcc = null;
            this.form.passbookDoc = null;
            this.form.vdR_BNK_SNO = null;

            if (sno === '' || sno === 0 || sno === -1) return;

            // 載入選取的委外個人資訊
            try {
                const resp = await this.$api({
                    url: 'ServiceOrder/GetPersonalOutsourcingBySno',
                    method: 'GET',
                    params: { sno },
                });

                this.selectedOutsourcing = resp.data.item;

                this.form.personalOutsourcingSno = resp.data.item.sno;
                this.form.nationality = resp.data.item.abd;

                // 證件類型
                // idTyp = 0 :身分證
                // idTyp = 1 :護照
                // idTyp = 2 :居留證
                // idTyp = 3 :營業統一編號
                if (resp.data.item.abd !== 0) {
                    // 外國籍
                    // identificationType = 1 :護照
                    // identificationType = 2 :居留證
                    this.form.idTyp = resp.data.item.identificationType;
                } else {
                    // 本國籍
                    // bsN_TYP = 1 :身分證
                    // bsN_TYP = 2 :統一編號
                    this.form.idTyp = resp.data.item.bsN_TYP === 1 ? 0 : 3;
                }

                this.form.bsn = resp.data.item.bsn;
                this.form.payee = resp.data.item.fnam;
                this.form.phone = resp.data.item.vendorContacts[0]?.tel;
                this.form.email = resp.data.item.vendorContacts[0]?.eml;
                this.form.permanentAddrCty = resp.data.item.permanentAddrCty;
                this.form.permanentAddr = resp.data.item.permanentAddr;
                this.form.permanentAddrAra = resp.data.item.permanentAddrAra;
                this.form.permanentAdR_CODE = resp.data.item.permanentAdR_CODE || null;
                this.form.adR_CODE = resp.data.item.adR_CODE || null;
                this.form.contactAddr = resp.data.item.adr;
                this.form.contactAddrAra = resp.data.item.ara;
                this.form.contactAddrCty = resp.data.item.cty;
                this.form.idCardFront = resp.data.item.idCardFront;
                this.form.idCardBack = resp.data.item.idCardBack;
                this.form.unionInsuranceDoc = resp.data.item.unionInsuranceDoc;
                this.form.hasUnionInsurance = resp.data.item.oS_GRP;
                this.form.unionInsuranceExpireDate = resp.data.item.unionInsuranceExpireDate;

                // 選取銀行，先選選第一筆帳戶資訊
                this.form.vdR_BNK_SNO = resp.data.item.vendorBanks && resp.data.item.vendorBanks.length > 0 ? resp.data.item.vendorBanks[0].sno : null; // 選取第一筆帳戶資訊

                // 如果 temp 有記錄上次變更前選取的帳戶，而且不是第一筆，就選該筆帳戶
                if (this.form.plannedPayWay === 2) {
                    if (prevVdrBnkSno !== this.form.vdR_BNK_SNO) {
                        if (resp.data.item.vendorBanks.find((b) => b.sno === prevVdrBnkSno)) {
                            this.form.vdR_BNK_SNO = prevVdrBnkSno;
                        }
                    }
                }

                this.onBnkChange(); // 帳戶資訊欄位更新
                this.updateAutoTaxAndGen2(); // 重新計算代扣
                this.updateRealPayAmt(); // 重新計算實付金額

                // 關閉編輯狀態
                this.isEnableEditCurrOutsourcing = false;
                this.isEnableEditCurrOutsourcingBank = false;

                // 重新針對委外資料的欄位驗證
                this.validateField([
                    'payee',
                    'idTyp',
                    'bsn',
                    'phone',
                    'permanentAddr',
                    'permanentAddrCty',
                    'permanentAddrAra',
                    'permanentAdR_CODE',
                    'contactAddr',
                    'contactAddrAra',
                    'contactAddrCty',
                    'adR_CODE',
                ]);
            } catch (e) {
                console.log(e);
                this.$message.error('無法取得委外勞務資料，請重新選取。');
            }
        },

        // 重新欄位驗證
        validateField(field) {
            setTimeout(() => {
                this.$refs.form.validateField(field);
            }, 300);
        },

        // 當更新所得稅率
        onTaxRatioChange() {
            this.updateTaxAmtByRatio();
            this.updateRealPayAmt();
        },

        // 當更新所得稅金額
        onTaxAmtChange() {
            this.taxAmtInOriginCny = this.form.taxAmt / this.form.cnyRat;
            this.updateRealPayAmt();
        },

        // 當更新二代健保稅率
        onGen2RatioChange() {
            this.updateGen2AmtByRatio();
            this.updateRealPayAmt();
        },

        // 當更新二代健保金額
        onGen2AmtChange() {
            this.gen2AmtInOriginCny = this.form.gen2Amt / this.form.cnyRat;
            this.updateRealPayAmt();
        },

        // 當應付金額變更
        onAmtChange() {
            // 有開啟自動稅率計算
            if (this.isEnableAutoTax) {
                this.updateAutoTaxAndGen2();
            }
            // 未開啟自動稅率計算，依使用者輸入%計算金額
            if (!this.isEnableAutoTax) {
                this.updateTaxAmtByRatio();
                this.updateGen2AmtByRatio();
            }
            this.updateRealPayAmt();
        },

        // 當幣別變更
        onCnyChange() {
            // 填入匯率
            this.form.cnyRat = this.getCnyRat(this.form.cny);

            // 台幣取到整數
            if (this.form.cny === 'TWD') {
                this.form.amt = Math.round(this.form.amt);
            }

            // 限制外幣不可選現金
            if (this.form.cny !== 'TWD') {
                this.form.plannedPayWay = 2;
            }
            // 觸發重新計算全部金額
            this.onCnyRatChange();
        },

        // 當外幣匯率變更
        onCnyRatChange() {
            this.onAmtChange(); // 重新計算全部金額
        },

        // 當按下建立委外勞務，顯示委外勞務編輯視窗關閉
        onAddOutsourcePerson() {
            this.outsourcingPersonUpsertDialog.sno = null;
            this.outsourcingPersonUpsertDialog.visible = true;
        },

        // 當按委外勞務編輯視窗關閉
        onOutsourcingPersonUpsertDialogClose() {
            this.outsourcingPersonUpsertDialog.sno = null;
            this.outsourcingPersonUpsertDialog.visible = false;
        },

        // 當委外勞務新增/編輯儲存
        async onOutsourcingPersonSubmitted(sno) {
            // 更新委外下拉列表
            await this.fetchOutsourcingList(!this.companyInfo.displayPersonalOutsource);

            // 觸發選到項目後的委外資料傳回 form
            this.onOutsourcingChange(sno);

            // 更新即時計算的金額
            this.updateAutoTaxAndGen2();
            this.updateRealPayAmt();
        },

        // 當變更所得類別
        onChangeIncomeType() {
            this.form.serviceType = null;
            this.onAmtChange();
        },

        // 當摘要輸入中，禁止換行
        onNamInputKeydown(event) {
            if (event.key === 'Enter' || event.code === 'Enter' || event.keyCode === 13) {
                // eslint-disable-next-line no-param-reassign
                event.returnValue = false;
                return false;
            }
            return true;
        },

        // 當變更是否自動計算稅率
        onChangeEnableAutoTax() {
            if (this.isEnableAutoTax) {
                this.updateAutoTaxAndGen2();
            }
        },

        // 當銀行帳戶變更
        onBnkChange() {
            if (this.form.vdR_BNK_SNO) {
                const bank = this.selectedOutsourcing.vendorBanks.find((b) => b.sno === this.form.vdR_BNK_SNO);
                if (bank) {
                    this.form.accountType = bank.accountType;
                    this.form.bnkBoo = bank.bnK_BOO;
                    this.form.bnkDoo = bank.bnK_DOO;
                    this.form.abroadBankName = bank.abroadBankName;
                    this.form.swiftCode = bank.swiftCode;
                    this.form.bnkNam = bank.bnK_TPC;
                    this.form.bnkAcc = bank.bnK_ACC;
                    this.form.bnkNote = bank.note;
                    this.form.passbookDoc = bank.passbookDoc;
                    this.form.vdR_BNK_SNO = bank.sno;
                    this.validateField(['accountType', 'bnkBoo', 'bnkDoo', 'bnkNam', 'bnkAcc', 'abroadBankName', 'swiftCode']);
                    return;
                }
            }

            this.form.bnkBoo = '';
            this.form.bnkDoo = '';
            this.form.abroadBankName = '';
            this.form.swiftCode = '';
            this.form.bnkNam = '';
            this.form.bnkAcc = '';
            this.form.passbookDoc = null;
            this.validateField(['accountType', 'bnkBoo', 'bnkDoo', 'bnkNam', 'bnkAcc', 'abroadBankName', 'swiftCode']);
        },

        // 正規化送出資料
        normalizeSubmitData() {
            // 付款方式：現金，去除銀行帳戶資訊
            if (this.form.plannedPayWay === 1) {
                this.form.accountType = null;
                this.form.bnkBoo = null;
                this.form.bnkDoo = null;
                this.form.abroadBankName = null;
                this.form.swiftCode = null;
                this.form.bnkNam = null;
                this.form.bnkAcc = null;
                this.form.vdR_BNK_SNO = null;
            }
        },

        // 送出
        async onSubmit() {
            try {
                this.$refs.form.validate(async (valid) => {
                    if (!valid) {
                        this.scrollViewToError();
                        return;
                    }
                    if (valid) {
                        this.normalizeSubmitData(this.form);

                        await this.$api({
                            url: 'ServiceOrder/UpsertServiceFeeStatement',
                            method: 'POST',
                            data: this.form,
                        });
                        this.$message({
                            showClose: true,
                            message: '已成功建立勞報單。',
                            type: 'success',
                        });
                        this.onClose();
                    }
                });
            } catch (e) {
                console.log(e);
                this.$message({
                    showClose: true,
                    message: '無法建立勞報單。',
                    type: 'success',
                });
            }
        },

        // 刪除勞報單
        async onDelete() {
            try {
                await this.$confirm('確定要刪除此勞報單？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                await this.$api({
                    url: 'ServiceOrder/DeleteServiceFeeStatement',
                    method: 'DELETE',
                    data: { sno: this.form.sno },
                });
                this.onClose();
            } catch (e) {
                console.log(e);
            }
        },

        // 當按下取消
        onClose() {
            this.$router.push({ name: 'service-fee-statement' });
        },

        // 取得即時匯率
        getCnyRat(cny) {
            const cnyOption = this.cnyOptions.find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },

        // 開啟自動計算稅率時，自動取得稅率＆稅金
        updateAutoTaxAndGen2() {
            const amt = this.form.amt * this.form.cnyRat; // 支付金額（台幣）
            const { incomeType } = this.form; // 所得類別
            const isResident = this.form.nationality !== 2; // 國籍 0:本國 & 1:外國(滿183天) = 居住者;  2:外國(未滿183天) = 非居住者

            // 勞務稅
            const taxInfo = getTaxAmtInfo(incomeType, amt, isResident);
            this.form.taxRatio = taxInfo.ratio;
            this.form.taX_CHK = taxInfo.amt > 0;
            this.form.taxAmt = taxInfo.amt;
            this.taxAmtInOriginCny = this.form.taxAmt / this.form.cnyRat;

            // 二代健保
            let hasUnionInsurance = false;
            if (this.form.hasUnionInsurance) {
                const endOfDay = moment().endOf('day');
                hasUnionInsurance = moment(this.form.unionInsuranceExpireDate).isAfter(endOfDay);
            }
            const gen2Info = getGen2AmtInfo(incomeType, amt, hasUnionInsurance);
            this.form.gen2Ratio = gen2Info.ratio;
            this.form.geN2_CHK = gen2Info.amt > 0;
            this.form.gen2Amt = gen2Info.amt;
            this.gen2AmtInOriginCny = this.form.gen2Amt / this.form.cnyRat;
        },

        // 自動計算實付金額
        updateRealPayAmt() {
            this.form.realPayAmt = Math.round(this.form.amt * this.form.cnyRat) - this.form.taxAmt - this.form.gen2Amt;
            this.realPayAmtInOriginCny = (Math.round(this.form.amt * this.form.cnyRat) - this.form.taxAmt - this.form.gen2Amt) / this.form.cnyRat;
            this.realPayAmtInOriginCny = Math.round(this.realPayAmtInOriginCny * 10000) / 10000;
        },

        // 自動計算勞務稅金額
        updateTaxAmtByRatio() {
            // 未開啟自動稅率，依使用者輸入 % 計算
            const taxRatio = this.form.taxRatio / 100;
            this.form.taxAmt = Math.floor(this.form.amt * this.form.cnyRat * taxRatio);
            this.taxAmtInOriginCny = Math.round((this.form.taxAmt / this.form.cnyRat) * 10000) / 10000;
        },

        // 自動計算二代健保金額
        updateGen2AmtByRatio() {
            // 未開啟自動稅率，依使用者輸入 % 計算
            const gen2Ratio = this.form.gen2Ratio / 100;
            this.form.gen2Amt = Math.round(this.form.amt * this.form.cnyRat * gen2Ratio);
            this.gen2AmtInOriginCny = Math.round((this.form.gen2Amt / this.form.cnyRat) * 10000) / 10000;
        },

        // 滾動到報錯的欄位
        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },

        // 編輯委外資料
        onOutsourcingEdit() {
            this.outsourcingPersonUpsertDialog.sno = this.form.personalOutsourcingSno;
            this.outsourcingPersonUpsertDialog.visible = true;
        },

        // 當文件圖片上傳
        onChangeAttachment(val, fieldName) {
            this.form[fieldName] = val.filE_ATT;
        },

        // 開始編輯"本次"委外資料
        enableEditCurrOutsourcing() {
            // 暫存編輯前資料，供按"取消"時恢復
            this.savedOutsouringData.nationality = this.form.nationality;
            this.savedOutsouringData.idTyp = this.form.idTyp;
            this.savedOutsouringData.bsn = this.form.bsn;
            this.savedOutsouringData.payee = this.form.payee;
            this.savedOutsouringData.phone = this.form.phone;
            this.savedOutsouringData.email = this.form.email;
            this.savedOutsouringData.permanentAddrCty = this.form.permanentAddrCty;
            this.savedOutsouringData.permanentAddr = this.form.permanentAddr;
            this.savedOutsouringData.permanentAddrAra = this.form.permanentAddrAra;
            this.savedOutsouringData.permanentAdR_CODE = this.form.permanentAdR_CODE;
            this.savedOutsouringData.adR_CODE = this.form.adR_CODE;
            this.savedOutsouringData.contactAddr = this.form.contactAddr;
            this.savedOutsouringData.contactAddrAra = this.form.contactAddrAra;
            this.savedOutsouringData.contactAddrCty = this.form.contactAddrCty;
            this.savedOutsouringData.idCardFront = this.form.idCardFront;
            this.savedOutsouringData.idCardBack = this.form.idCardBack;
            this.savedOutsouringData.unionInsuranceDoc = this.form.unionInsuranceDoc;
            this.savedOutsouringData.hasUnionInsurance = this.form.hasUnionInsurance;
            this.savedOutsouringData.unionInsuranceExpireDate = this.form.unionInsuranceExpireDate;

            this.isEnableEditCurrOutsourcing = true;
        },

        // 「確認」(關閉) 當前編輯委外資訊
        closeEditCurrOutsourcing() {
            this.isEnableEditCurrOutsourcing = false;
        },

        // 「取消」(恢復) 當前編輯委外資訊
        cancelEditCurrOutsourcing() {
            this.form.nationality = this.savedOutsouringData.nationality;
            this.form.idTyp = this.savedOutsouringData.idTyp;
            this.form.bsn = this.savedOutsouringData.bsn;
            this.form.payee = this.savedOutsouringData.payee;
            this.form.phone = this.savedOutsouringData.phone;
            this.form.email = this.savedOutsouringData.email;
            this.form.permanentAddrCty = this.savedOutsouringData.permanentAddrCty;
            this.form.permanentAddr = this.savedOutsouringData.permanentAddr;
            this.form.permanentAddrAra = this.savedOutsouringData.permanentAddrAra;
            this.form.permanentAdR_CODE = this.savedOutsouringData.permanentAdR_CODE;
            this.form.adR_CODE = this.savedOutsouringData.adR_CODE;
            this.form.contactAddr = this.savedOutsouringData.contactAddr;
            this.form.contactAddrAra = this.savedOutsouringData.contactAddrAra;
            this.form.contactAddrCty = this.savedOutsouringData.contactAddrCty;
            this.form.idCardFront = this.savedOutsouringData.idCardFront;
            this.form.idCardBack = this.savedOutsouringData.idCardBack;
            this.form.unionInsuranceDoc = this.savedOutsouringData.unionInsuranceDoc;
            this.form.hasUnionInsurance = this.savedOutsouringData.hasUnionInsurance;
            this.form.unionInsuranceExpireDate = this.savedOutsouringData.unionInsuranceExpireDate;

            this.isEnableEditCurrOutsourcing = false;
        },

        // 開始編輯"本次"委外帳戶資料
        enableEditCurrOutsourcingBank() {
            // 暫存編輯前資料，供按"取消"時恢復
            this.savedOutsouringData.accountType = this.form.accountType;
            this.savedOutsouringData.bnkAcc = this.form.bnkAcc;
            this.savedOutsouringData.bnkBoo = this.form.bnkBoo;
            this.savedOutsouringData.bnkDoo = this.form.bnkDoo;
            this.savedOutsouringData.bnkNam = this.form.bnkNam;
            this.savedOutsouringData.abroadBankName = this.form.abroadBankName;
            this.savedOutsouringData.swiftCode = this.form.swiftCode;
            this.savedOutsouringData.passbookDoc = this.form.passbookDoc;

            this.isEnableEditCurrOutsourcingBank = true;
        },

        // 「確認」(關閉) 當前編輯付款帳戶
        closeEditCurrOutsourcingBank() {
            this.isEnableEditCurrOutsourcingBank = false;
        },

        // 「取消」(恢復) 當前編輯付款帳戶
        cancelEditCurrOutsourcingBank() {
            this.form.accountType = this.savedOutsouringData.accountType;
            this.form.bnkAcc = this.savedOutsouringData.bnkAcc;
            this.form.bnkBoo = this.savedOutsouringData.bnkBoo;
            this.form.bnkDoo = this.savedOutsouringData.bnkDoo;
            this.form.bnkNam = this.savedOutsouringData.bnkNam;
            this.form.abroadBankName = this.savedOutsouringData.abroadBankName;
            this.form.swiftCode = this.savedOutsouringData.swiftCode;
            this.form.passbookDoc = this.savedOutsouringData.passbookDoc;

            this.isEnableEditCurrOutsourcingBank = false;
        },

        // 變更預計支領方式
        onChangePlannedPayWay() {
            // 如果選擇銀行轉帳，自動選取第一筆銀行
            if (this.form.plannedPayWay === 2) {
                if (this.selectedOutsourcing) {
                    if (this.selectedOutsourcing.vendorBanks.length >= 1) {
                        this.$nextTick(() => {
                            this.form.vdR_BNK_SNO = this.selectedOutsourcing.vendorBanks[0].sno;
                            this.onBnkChange();
                        });
                    }
                }
            }
        },

        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
        getOutsourcingBankLabel(item) {
            if (item.accountType === 1) {
                if (item.bnk_DOO) {
                    return `（${item.bnK_DOO}）${item.bnK_TPC}: ${item.bnK_ACC}`;
                }
                return `${item.bnK_TPC}: ${item.bnK_ACC}`;
            }
            return `（${item.abroadBankName}）${item.bnK_TPC}: ${item.bnK_ACC}`;
        },
        getOutsourcingNoDataText() {
            if (!this.companyInfo.displayPersonalOutsource && this.outsourcingQuery.length < 2) {
                return '請輸入兩個字以上的關鍵字';
            }
            return '無匹配資料';
        },
    },
};
</script>

<style lang="scss">
.service-fee-statement-edit-page {
    .ah-panel {
        margin-bottom: 10px;
    }
    .outsourcing-form-card {
        background-color: #fff;
        padding: 30px 50px 30px 20px;
        border-radius: 15px;
        border: 1px solid #ddd;
        // margin: 0 0 30px 200px;
        box-shadow: 2px 3px 13px rgba(0, 0, 0, 0.15);

        @media (min-width: 720px) {
            margin: 0 0 30px 200px;
        }

        .el-input.is-disabled .el-input__inner {
            border-color: transparent;
        }
        .el-form-item.is-error {
            .el-input.is-disabled .el-input__inner {
                border-color: #f56c6c;
            }
        }

        .card-action {
            display: flex;
            justify-content: end;
            margin-bottom: 30px;
        }

        .id-card-image {
            width: 100%;
            > img {
                object-fit: contain;
                aspect-ratio: 1.574;
                border: 1px solid #ddd;
            }

            &.none {
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #ddd;
                width: 100%;
                aspect-ratio: 1.574;
            }
        }
        .doc-image {
            width: 100px;
            > img {
                object-fit: contain;
                aspect-ratio: 1;
                border: 1px solid #ddd;
            }
        }

        .card-footer {
            display: flex;
            border-top: 1px solid #eee;
            padding-top: 20px;
            justify-content: space-between;
        }
    }
    .outsourcing-field-required-msg {
        font-size: 9pt;
        color: #ff3c3c;
        background-color: #fdf1f1;
        padding: 7px 13px;
        margin-right: 10px;
        border-radius: 4px;

        i {
            margin-right: 5px;
        }
    }
}
</style>
